<div class="content-without-stepper-and-title identification-summary">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="img-success">
        <img src="assets/images/success-process.svg" alt="error_img" class="error_img" id="imgProcessSuccesfully">
      </div>

      <div id="summarySuccessTitle" class="text" [innerHTML]="copyService.getParametrizedCopy('identification_summary_success_title', [documentInfo.firstname])">
      </div>
    </div>
  </div>
  <app-controls id="identificationSummaryBtns" [nextLabel]="copyService.copies.identification_summary_button" (next)="next()">
  </app-controls>
</div>
